////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const salesHistoryByCodes = {
	getHistoCode: (filters = {}, queryParams = { page: '0', size: '250', sort: 'saleOrder.createdDate', nameDir: 'desc' }) => ({
		type: ActionsTypes.GET_HISTO_CODE,
		payload: {
			filters,
			queryParams,
		},
	}),
	getHistoCodeSuccess: (data) => ({
		type: ActionsTypes.GET_HISTO_CODE_SUCCESS,
		payload: {
			data,
		},
	}),
	getHistoCodeFailure: (error) => ({
		type: ActionsTypes.GET_HISTO_CODE_FAILURE,
		payload: {
			error,
		},
	}),

	postDisplayTicket: (kiosksInLocalScope = {}, salesOrderId) => ({
		type: ActionsTypes.POST_DISPLAY_TICKET,
		payload: {
			salesOrderId,
			kiosksInLocalScope,
		},
	}),
	postDisplayTicketSuccess: (data) => ({
		type: ActionsTypes.POST_DISPLAY_TICKET_SUCCESS,
		payload: {
			data,
		},
	}),
	postDisplayTicketFailure: (error) => ({
		type: ActionsTypes.POST_DISPLAY_TICKET_FAILURE,
		payload: {
			error,
		},
	}),

	getTransactionId: (salesByCodes) => ({
		type: ActionsTypes.GET_TRANSACTION_ID,
		payload: {
			salesByCodes,
		},
	}),

	postReviewTicket: (kiosksInLocalScope = {}, salesOrderId) => ({
		type: ActionsTypes.POST_REVIEW_TICKET,
		payload: {
			salesOrderId,
			kiosksInLocalScope,
		},
	}),
	postReviewTicketSuccess: (data) => ({
		type: ActionsTypes.POST_REVIEW_TICKET_SUCCESS,
		payload: {
			data,
		},
	}),
	postReviewTicketFailure: (error) => ({
		type: ActionsTypes.POST_REVIEW_TICKET_FAILURE,
		payload: {
			error,
		},
	}),

	postSmsTicket: (kiosksInLocalScope = {}, salesOrderId) => ({
		type: ActionsTypes.POST_SMS_TICKET,
		payload: {
			salesOrderId,
			kiosksInLocalScope,
		},
	}),
	postSmsTicketSuccess: (data) => ({
		type: ActionsTypes.POST_SMS_TICKET_SUCCESS,
		payload: {
			data,
		},
	}),
	postSmsTicketFailure: (error) => ({
		type: ActionsTypes.POST_SMS_TICKET_FAILURE,
		payload: {
			error,
		},
	}),

	postDeleteSaleCode: (kiosksInLocalScope = {}, salesOrderId) => ({
		type: ActionsTypes.POST_DELETE_SALE_CODE,
		payload: {
			salesOrderId,
			kiosksInLocalScope,
		},
	}),
	postDeleteSaleCodeSuccess: (data) => ({
		type: ActionsTypes.POST_DELETE_SALE_CODE_SUCCESS,
		payload: {
			data,
		},
	}),
	postDeleteSaleCodeFailure: (error) => ({
		type: ActionsTypes.POST_DELETE_SALE_CODE_FAILURE,
		payload: {
			error,
		},
	}),

	postCancelSaleCode: (kiosksInLocalScope = {}, salesOrderId) => ({
		type: ActionsTypes.POST_CANCEL_SALE_CODE,
		payload: {
			salesOrderId,
			kiosksInLocalScope,
		},
	}),
	postCancelSaleCodeSuccess: (data) => ({
		type: ActionsTypes.POST_CANCEL_SALE_CODE_SUCCESS,
		payload: {
			data,
		},
	}),
	postCancelSaleCodeFailure: (error) => ({
		type: ActionsTypes.POST_CANCEL_SALE_CODE_FAILURE,
		payload: {
			error,
		},
	}),

	postRenewCode: (kiosksInLocalScope = {}, salesOrderId) => ({
		type: ActionsTypes.POST_RENEW_CODE,
		payload: {
			kiosksInLocalScope,
			salesOrderId,
		},
	}),
	postRenewCodeSuccess: (data) => ({
		type: ActionsTypes.POST_RENEW_CODE_SUCCESS,
		payload: {
			data,
		},
	}),
	postRenewCodeFailure: (error) => ({
		type: ActionsTypes.POST_RENEW_CODE_FAILURE,
		payload: {
			error,
		},
	}),
	resetHistoCodeItems: () => ({
		type: ActionsTypes.RESET_HISTO_CODE_ITEMS,
	}),
}

export default salesHistoryByCodes
